<div class="d-flex justify-content-center justify-content-sm-start pb-3">
  <img
    [src]="content.avatar"
    class="img-fluid d-flex user-profile-avatar"
    data-test-id="current-user-avatar"
    default="{{ NO_PHOTO_DEFAULT_IMAGE }}"
  />
</div>
<div>
  <div [attr.data-test-id]="'current-user-name'">
    <h1 class="text-break">
      {{ content.displayedName }}
      <span [attr.data-test-id]="'status-badge'" class="text-muted ps-2 mt-1">{{ getStatusMark() | translate }}</span>
    </h1>
  </div>
  <a
    *ngIf="content.isOrganization && locationUser"
    class="btn btn-link d-inline-flex align-items-center mb-4"
    data-test-id="activate-organization-location"
    target="_blank"
    [routerLink]="['/map', mapFilters.ORGANIZATIONS.toLowerCase()]"
    [queryParams]="{ id: user.user_id }"
    [ngbTooltip]="'TOOLTIP_SEE_ON_MAP' | translate"
  >
    <svg-icon src="assets/icons/icon-map-pin.svg" class="icon-location-pin mb-1 mr-1"></svg-icon>
    <h5 class="mb-0">{{ locationUser }}</h5>
  </a>
  <h5 *ngIf="!content.isOrganization && locationUser" class="mb-4" data-test-id="inactive-user-location">
    {{ locationUser }}
  </h5>
  <h5 *ngIf="additionalTitle" class="mb-4" [attr.data-test-id]="'additional-title'">
    {{ additionalTitle | translate }}
  </h5>
  <div *ngIf="!isHiddenUserData" class="roles-tabs" [attr.data-test-id]="'roles-tabs'">
    <ul
      ngbNav
      #nav="ngbNav"
      [activeId]="activeId"
      [destroyOnHide]="true"
      (navChange)="onActiveTabChanged($event)"
      class="nav-tabs"
    >
      <li
        *ngFor="let role of content.data; index as i; trackBy: trackByRole"
        [attr.id]="'title-info_' + i"
        [ngbNavItem]="role.userType"
      >
        <a ngbNavLink [attr.data-test-id]="'title-name-info_' + i">
          {{ role.userType | translate }}
        </a>

        <ng-template ngbNavContent>
          <app-user-role-tab [role]="role"></app-user-role-tab>
        </ng-template>
      </li>
    </ul>
    <div [ngbNavOutlet]="nav"></div>
  </div>
</div>
